import type { ComponentProps } from 'react';

import { Text } from '@change/ds-core-ui/next';

import type { Comment } from '../../../../pageContext';

import { CommentHeader } from './CommentHeader/index_new';
import { useCommentCard } from './hooks/useCommentCard';

type Props = {
	comment: Comment;
};

export function CommentCard({ comment, ...rest }: Props & ComponentProps<'div'>) {
	const {
		data: { comment: commentText },
	} = useCommentCard(comment);

	return (
		<>
			<div
				{...rest}
				className="flex min-h-[40px] w-full items-center"
				data-qa={`comment-card-${comment.id}`}
				data-expanded
			>
				<CommentHeader comment={comment} />
			</div>
			<div className="mb-[15px] ml-10 self-stretch">
				<Text as="div" className="whitespace-pre-wrap" data-qa="comment-body">
					&quot;{commentText}&quot;
				</Text>
			</div>
		</>
	);
}
